export const CITY_DELETE_RESET = 'CITY_DELETE_RESET'
export const CITY_DELETE_SET_ERROR = 'CITY_DELETE_SET_ERROR'
export const CITY_DELETE_SET_DELETED = 'CITY_DELETE_SET_DELETED'
export const CITY_DELETE_TOGGLE_LOADING = 'CITY_DELETE_TOGGLE_LOADING'
